"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warnOnce = void 0;
/**
 * This is a convenience utility that's mostly used for dev-only
 * warnings that are stripped out in production builds.
 *
 * Example:
 *
 * import { warnOnce } from "@smartsheet/lodestar-utils";
 *
 * interface MyComponentProps {
 *   propA: string;
 *   // @deprecated, though actually use a block comment here please.
 *   propB: string;
 * }
 *
 * const MyComponent = (props: MyComponentProps) => {
 *   if (process.env.NODE_ENV !== "production") {
 *     if (props.propB) {
 *       warnOnceForDeprecatedProp =
 *         warnOnceForDeprecatedProp ??
 *         warnOnce(
 *           "MyComponent: propB is deprecated. Please use propA instead."
 *         );
 *       warnOnceForDeprecatedProp();
 *     }
 *   }
 *
 *   return <div>yay</div>;
 * };
 *
 * // Lazily initialize the warning for ultra tree-shaking.
 * let warnOnceForDeprecatedProp: (() => void) | null;
 *
 */
const warnOnce = msg => {
  let warned = false;
  return () => {
    if (warned) return;
    warned = true;
    console.warn(msg);
  };
};
exports.warnOnce = warnOnce;
//# sourceMappingURL=warnOnce.js.map